module.exports = __webpack_public_path__ + "static/banner-image-ee9bdd7b64e8a3d87223fb2fa0c96fb2.png";